import { Component, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ITooltipAngularComp } from 'ag-grid-angular';
import type { ITooltipParams } from 'ag-grid-community';
import { TranslateModule } from '@ngx-translate/core';
import { SharedTranslationModule } from '@shared/translation.module';

@Component({
  selector: 'md-grid-tooltip',
  imports: [MatIcon, TranslateModule, SharedTranslationModule],
  templateUrl: './grid-tooltip.component.html',
  styleUrl: './grid-tooltip.component.scss',
  standalone: true
})
export class GridTooltipComponent implements ITooltipAngularComp {
  params!: ITooltipParams<unknown, { diff: { path: string; __old: string; __new: string }[] }, unknown>;
  diff = signal<{ path: string; __old: string; __new: string }[]>([]);

  agInit(params: ITooltipParams<unknown, { diff: { path: string; __old: string; __new: string }[] }, unknown>): void {
    this.params = params;
    this.diff.set(params.value?.diff ?? []);
  }
}
